import React from 'react';

/** Kanonische AGB-URL (Landing: /recht#agb) — Haftung & Prüfpflicht § 5. */
export const ARKO_AGB_SECTION_URL = 'https://arkorbit.at/recht#agb';

/** AI-Transparenz / Maschinenlesbare Fakten (Art. 50) — getrennt von AGB. */
export const ARKO_AI_TRANSPARENCY_URL = 'https://arkorbit.at/ai.txt';

interface ArkoChatAiActNoticeProps {
  compact?: boolean;
  className?: string;
}

/**
 * EU AI Act Art. 50 — permanenter, dezenter Chatbot-Hinweis (Kanzlei-Portal).
 * Ergänzt ARKO-Labels; ersetzt sie nicht.
 * AGB § 5 und ai.txt sind getrennte Links — nicht vermischen.
 */
export const ArkoChatAiActNotice: React.FC<ArkoChatAiActNoticeProps> = ({
  compact = false,
  className = '',
}) => (
  <p
    role="note"
    className={`text-center leading-relaxed text-slate-600 ${
      compact ? 'text-[10px] px-2 py-1' : 'text-[11px] px-3 py-1.5'
    } ${className}`}
  >
    Sie interagieren mit einem KI-System. Keine Rechtsberatung — Inhalte von Ihrem Anwalt prüfen
    lassen.{' '}
    <a
      href={ARKO_AGB_SECTION_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="text-slate-500 underline underline-offset-2 hover:text-slate-400"
    >
      AGB § 5
    </a>
    {' · '}
    <a
      href={ARKO_AI_TRANSPARENCY_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="text-slate-500 underline underline-offset-2 hover:text-slate-400"
    >
      AI-Transparenz
    </a>
  </p>
);
